require('./style.less');

var _ = require('underscore'),
    DrawablePageNoteView = require('../drawableNote'),
    GraphicStampSelectorView = require('./graphicStampSelector/view'),
    fvChannel = require('glRadio').channel('FV');


module.exports = DrawablePageNoteView.extend({

    initialize: function() {

        DrawablePageNoteView.prototype.initialize.apply(this, arguments);
        this.stampSelectView = null;
        this.userChangedSubjectInput = false; //(only applies if the note is new)

    },
    templateHelpers: _.extend( {}, DrawablePageNoteView.prototype.templateHelpers, {

        isGraphicStamp: function()
        {
            return true;
        },

        // TODO: may need to rid since can't derive the proper page rotation -- awaiting feedback
        // fyi: 0 in the new response isn't 0 rotation: its the rotation of page at the time it was created
        stampNoteSrc: function() {
            return !this.isNew
                ?  this.note.getImgSource()
                : ''; // should never get here
        },
        subject: function() {
            return this.isNew
                ? this.note.uiModel.get('selectedStamp').get('subject') //should always exist, if not, user can't create new stamp note
                : this.note.getSubject();
        }
    }),

    ui: _.extend( {}, DrawablePageNoteView.prototype.ui, {
        imgSelectPlaceholder:       '[data-stamp-select-holder]',
        savedImgPreview:            '.savedStampImgPreview'
    }),

    // use events: triggers are 'forwarded'
    events: _.extend( {}, DrawablePageNoteView.events, {
        'keypress @ui.noteSubject'   :   'userChangedNoteSubject'
    } ),

    userChangedNoteSubject: function() {
        // tab, arrows (others, etc) won't detect keypress ... could put in more intricate logic to detect if there was a change
        this.model.isNew() && (this.userChangedSubjectInput = true);
    },

    onRender: function() {
        DrawablePageNoteView.prototype.onRender.apply(this, arguments);
        this._createStampSelectView();
    },

    _createStampSelectView: function() {

        this.stampSelectView = new GraphicStampSelectorView({
            graphicStamps: fvChannel.request('user').getGraphicStamps(), // should pass this down for a bit of perf gain ...
            notesChannel: this.channel, // now not using ... pass for time being ...
            parent: this,
            initialStamp: this.uiModel.get('selectedStamp'),
            noteModel: this.model
        });

        this.ui.imgSelectPlaceholder.replaceWith( this.stampSelectView.render().el );

    },

    onShow: function() {

        // currently 'super' doesn't have onShow method but call in case it ever does
        var superOnShow = DrawablePageNoteView.prototype.onShow;
        superOnShow && superOnShow.apply(this, arguments);

        // pass down the on show method to the child view
        // this should be a layout/region so we could hook into the events but dont want to break what exist
        // a better refactor would be to update to MUCH newer version of Marionette, where I believe all views inherit this functionality
        this.stampSelectView.triggerMethod('show');

    },
    // ( bubbles from the child view )
    onUserChangedStamp: function(stamp) {

        this.uiModel.set( 'selectedStamp', stamp, {silent: true} );

        // if a new note, automatically change the subject if the user didn't type put another value in there
        if ( this.model.isNew() && !this.userChangedSubjectInput )
            this.ui.noteSubject.val( stamp.get('subject') );

        // select the text of the subject text box as an indication to the user that they may want to change the title
        // do in a timeout b/c of Chosen.prototype.search_results_mouseup, which will over-write the select
        // do for new as well as modify to emphasize the change (even though new may change what's in there)
        setTimeout ( _.bind( function() {
            this.ui.noteSubject.select();
        }, this), 250 );

        this.channel.trigger('notes:graphicStampChanged', stamp, this.model);

    },
    onBeforeDestroy: function() {

        this.stampSelectView.destroy();
        DrawablePageNoteView.prototype.onBeforeDestroy.apply(this, arguments);

    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/graphicStamp/view.js
 ** module id = 303
 ** module chunks = 0
 **/